<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="2" class="back-icon-button">
        <router-link :to="'/class/' + $route.params.class_id + '/homeworks'" class="icon-link">
          <i class="el-icon-document homework-title-icon"></i>
        </router-link>
        <div class="back-to-list-text">Back</div>
      </el-col>
      <el-col :span="22">
        <div class="deadline">Deadline: {{ deadline }}</div>
        <div class="homework-title">{{ name }}</div>
        <div class="avatar-container">
          <div :style="`background-image: url(${teacher.avatar});`" class="avatar-img" />
          <span class="avatar-text">
            <span class="teacher-name">{{ teacher.name }}</span>
            <span class="release-time">{{ release_time }}</span>
          </span>
        </div>
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getHomeworkWithCommentsById } from "@/api";

export default {
  name: "HomeworkInfo",
  data() {
    return {
      name: "",
      release_time: "",
      deadline: "",
      teacher: {
        name: "",
        avatar: ""
      }
    };
  },
  mounted() {
    this.getHomeworkInfo();
  },
  beforeDestroy() {
    this.clearCurrentHomework();
  },
  methods: {
    ...mapMutations(["setCurrentHomework", "clearCurrentHomework"]),
    getHomeworkInfo() {
      getHomeworkWithCommentsById(this.$route.params.homework_id).then(res => {
        this.name = res.name;
        this.release_time = res.release_time;
        this.deadline = res.deadline;
        this.teacher = res.teacher;
        this.setCurrentHomework(res);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.back-icon-button {
  color: rgba(0, 0, 0, 0.49);
  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }
  .icon-link {
    color: inherit;
    .homework-title-icon {
      font-size: 24px;
      margin: 24px;
      margin-bottom: 8px;
      color: inherit;
    }
  }
  .back-to-list-text {
    font-size: 14px;
    margin-left: 24px;
  }
}

.homework-title {
  font-size: 24px;
  margin-bottom: 16px;
}
.deadline {
  color: rgba(0, 0, 0, 0.49);
  font-size: 14px;
  margin: 24px 0;
}
.avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
  padding: 4px 0;
  border-bottom: 1px rgba(0, 0, 0, 0.25) solid;
  .avatar-img {
    width: 32px;
    height: 32px;
    background-position: center 10%;
    background-size: cover;
    border: 1px rgba(0, 0, 0, 0.25) solid;
    border-radius: 50%;
    overflow: hidden;
  }
  .avatar-text {
    flex-grow: 1;
    height: 32px;
    line-height: 32px;
    > span {
      height: 100%;
      vertical-align: middle;
    }
    .teacher-name {
      margin-left: 16px;
      font-size: 14px;
      font-weight: 600;
    }
    .release-time {
      color: rgba(0, 0, 0, 0.25);
      font-size: 12px;
      margin-left: 24px;
    }
  }
}
</style>